// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import withConfig from '../../../hoc/WithConfig';
import Icon from '../../shared/Icons/Icon';
import messages from '../../shared/Footer/messages';
import styles from './styles';
import { Link } from '../../../router';
import { VERTICAL_NAMES } from '../../../common/constants/common';
import GuideLink from './GuideLink';

type Props = {
  config: Object,
  shouldShowSocialMedia: ?boolean,
};

const { blog, your, about, join, help, privacy, cookie, legal, followUs, topSearches } = messages;

export function FooterMobile({ config, shouldShowSocialMedia }: Props): React.Node {
  /* eslint-disable no-param-reassign */
  return (
    <footer data-test="footer">
      <div className="social">
        {shouldShowSocialMedia && (
          <div>
            <p>
              <FormattedMessage {...followUs} />
            </p>
            <div>
              <a href="https://www.facebook.com/trovit.search/" rel="nofollow">
                <Icon type="facebook" width={24} />
              </a>
              <a href="https://twitter.com/Trovit" rel="nofollow">
                <Icon type="twitter" width={24} />
              </a>
              <a href="https://plus.google.com/+trovit" rel="nofollow">
                <Icon type="gplus" width={24} />
              </a>
            </div>
          </div>
        )}
      </div>
      <p>
        {config.verticalName === VERTICAL_NAMES.products && (
          <Link route="topsearches">
            <a>
              <FormattedMessage {...topSearches} />
            </a>
          </Link>
        )}
        <a href={config.vertical.blog_url} target="_blank" rel="noopener noreferrer">
          <FormattedMessage {...blog} />
        </a>
        {config.vertical.guideUrls && (
          <GuideLink verticalName={config.verticalName} url={config.vertical.guideUrls.main} />
        )}
        <a href={config.vertical.partners_url} target="_blank" rel="nofollow, noopener noreferrer">
          <FormattedMessage {...your} />
        </a>
        <a href={config.vertical.about_us_url} target="_blank" rel="nofollow, noopener noreferrer">
          <FormattedMessage {...about} />
        </a>
        <a href={config.vertical.careers_url} target="_blank" rel="nofollow, noopener noreferrer">
          <FormattedMessage {...join} />
        </a>
        <a href={config.vertical.help_url} target="_blank" rel="nofollow, noopener noreferrer">
          <FormattedMessage {...help} />
        </a>
        <a href={config.vertical.privacy_url} target="_blank" rel="nofollow, noopener noreferrer">
          <FormattedMessage {...privacy} />
        </a>
        <a
          href={config.vertical.cookie_disclaimer_url}
          target="_blank"
          rel="nofollow, noopener noreferrer"
        >
          <FormattedMessage {...cookie} />
        </a>
        <a href={config.vertical.legal_url} target="_blank" rel="nofollow, noopener noreferrer">
          <FormattedMessage {...legal} />
        </a>
      </p>
      <style jsx>{styles}</style>
    </footer>
  );
}

FooterMobile.defaultProps = {
  shouldShowSocialMedia: false,
};

export default withConfig(FooterMobile);



// WEBPACK FOOTER //
// ./app/components/mobile/Footer/index.js